export const errAuthMsg = {
  "auth/invalid-email": "La dirección de correo electrónico no es válida",
  "auth/user-disabled": "El usuario ha sido deshabilitado",
  "auth/user-not-found":
    "No hay un usuario con ese correo o podría haber sido eliminado",
  "auth/wrong-password": "Correo o contraseña inválidos",
  "auth/too-many-requests":
    "¡Se excedió los intentos de inicio de sesión, reestablezca la contraseña para acceder!",
  "firestore/unavailable": "servicio no disponible",
}

export const fbErrMsg = {
  "firestore/unavailable": "servicio no disponible",
  "firestore/cancelled": "operación cancelada",
  "firestore/unknown": "error desconocido",
  "firestore/invalid-argument": "hay un dato inválido",
  "firestore/deadline-exceeded": "tiempo excedido",
  "firestore/not-found": "documento no encontrado",
  "firestore/already-exists": "ya existe la información que intenta guardar",
  "firestore/permission-denied": "no tiene permisos para está acción",
  "firestore/resource-exhausted": "recurso agotado",
  "firestore/failed-precondition": "no se puede procesar la petición",
  "firestore/aborted": "petición abortada",
  "firestore/out-of-range": "se intentó fuera del tiempo válido",
  "firestore/unimplemented": "operación no disponible",
  "firestore/internal": "error interno",
  "firestore/data-loss": "datos perdidos o corruptos",
  "firestore/unauthenticated": "autorización inválida para esta acción",
}

export const PeriodosAreas = {
  iterator: [
    { label: "Diaria", value: 1 },
    { label: "Semanal", value: 7 },
    { label: "Mensual", value: 30 },
    { label: "Anual", value: 365 },
  ],
  values: {
    1: "Diaria",
    7: "Semanal",
    30: "Mensual",
    365: "Anual",
  },
}

export const TipoReporte = {
  values: {
    1: "Quejas",
    2: "Reclamos",
    3: "Peticiones",
    4: "Sugerencias",
    5: "Felicitaciones",
    6: "Otros",
  },
}

export const Estado = {
  values: {
    0: "Pendiente",
    1: "En progreso",
    2: "Completado",
    3: "Calificado",
  },
}

export const Calificacion = {
  values: {
    0: "Pendiente de calificar",
    1: "Nivel de satisfacción malo",
    2: "Nivel de satisfacción regular",
    3: "Nivel de satisfacción medio",
    4: "Nivel de satisfacción bueno",
    5: "Nivel de satisfacción excelente",
  },
}

export const Roles = {
  superadmin: "superAdministrador",
  admin: "administrador",
  supervisor: "supervisor",
  company: "empresa",
  parkey: "parkey",
  directiva: "directiva",
  puntoVenta: "puntoVenta",
  // resident: 'residente',
}

export const basePaths = {
  [Roles.superadmin]: "/superAdmin",
  [Roles.admin]: "/administrador",
  [Roles.supervisor]: "/guardia",
  [Roles.company]: "/empresa",
  [Roles.parkey]: "/parkey",
  [Roles.directiva]: "/directiva",
  [Roles.puntoVenta]: "/puntoVenta",
}

export const RUBROS_TYPE = {
  expensas: "Expensas",
  inFavor: "Saldos a favor",
  descuentos: "Descuentos",
  reservas: "Reservas",
  interesMora: "Intereses por mora",
  comisionPagosPlux: "ComisionPagosPlux",
}

export const defaultRubros = new Map([
  [
    RUBROS_TYPE.expensas,
    { Rubro: "Ingresos ordinarios", SubRubro: "Alícuota mensual" },
  ],
  [
    RUBROS_TYPE.inFavor,
    { Rubro: "Ingresos ordinarios", SubRubro: "Saldo a favor" },
  ],
  [
    RUBROS_TYPE.descuentos,
    { Rubro: "Ingresos extraordinarios", SubRubro: "Descuento" },
  ],
  [
    RUBROS_TYPE.reservas,
    { Rubro: "Ingresos extraordinarios", SubRubro: "Reserva áreas comunales" },
  ],
  [
    RUBROS_TYPE.interesMora,
    { Rubro: "Ingresos ordinarios", SubRubro: "Intereses por mora" },
    RUBROS_TYPE.comisionPagosPlux,
    { Rubro: "Ingresos extraordinarios", SubRubro: "Comisiones bancarias" },
  ],
])

export const defaultFormaCobroPago = [
  {
    name: "Efectivo",
    showCaja: true,
    showBancos: false,
  },
  {
    name: "Cheque",
    showCaja: true,
    showBancos: false,
  },
  {
    name: "Transferencia",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Deposito",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Tarjeta credito/debito",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Nota de debito",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Debito bancario",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Debito",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Intereses",
    showCaja: false,
    showBancos: true,
  },
  {
    name: "Cheque en banco",
    showCaja: false,
    showBancos: true,
  },
]

export const defaultTipoVisitas = [
  {
    Nombre: "Visita",
    Valor: 0,
    Tiempo: "Sin Tiempo",
  },
  {
    Tiempo: "1 hora",
    Nombre: "Empleado",
    Valor: 1,
  },
  {
    Valor: 2,
    Tiempo: "2 horas",
    Nombre: "Servicio de entregas",
  },
  {
    Nombre: "Servicio de taxi",
    Tiempo: "15 minutos",
    Valor: 0.25,
  },
  {
    Nombre: "Residente",
    Tiempo: "Indefinido",
    Valor: 0,
  },
  {
    Tiempo: "2 horas",
    Nombre: "Servicio de emergencia",
    Valor: 2,
  },
  {
    Valor: 1,
    Nombre: "Proveedor",
    Tiempo: "1 hora",
  },
  {
    Valor: 0,
    Tiempo: "Sin Tiempo",
    Nombre: "Paciente",
  },
  {
    Nombre: "Otro",
    Valor: 0,
    Tiempo: "Sin Tiempo",
  },
]

export const defaultModules = {
  QrPrint: false,
  Anulacion: false,
  CorreosAdicionales: false,
  IngresosEmail: false,
  NotificacionPorUsuario: false,
  VerReservas: false,
  Recordatorios: false,
  CompareFaces: false,
  LectorQrCedula: false,
  InformacionVehiculo: false,
  EmailNovedades: false,
  CorreoNovedadesDefault: "",
  IngresosMasivos: false,
  CalculoExpensas: false,
  PlacasResidentes: false,
  TagsResidentes: false,
  Pets: false,
  ResidentDebtsReport: false,
  ResumenCuentasPorCobrar: false,
  Mudanza: false,
  Parqueaderos: false,
  FacturacionElectronica: false,
  Contifico: false,
  QrRecurrente: false,
  FechaIngreso: false,
  Planilla: false,
  Presupuesto: false,
  QRPin: false,
  QrElevator: false,
  QrSize: false,
  ReservasEmail: false,
  ResidentConsolidadoReport: false,
  LimitBitacora: false,
  JoinGuardBinnacle: false, // Permite que un cambio de guardia se guarde tambien como una bitácora
  Aprobadores: false,
  AlertaDestinoBloqueado: false,
  DeleteGuards: true,
  Proforma: false,
  WppPanicAlert: false,
  FechaImpresionEgreso: false,
  PrintRasp: false,
  PrintApp: false,
  placasPSQL: false,
  Chequera: false,
  SaveQR: false,
  TagsLocal: false,
  PagoAnual: false,
  ProntoPago: false,
  FechaBanco: false,
  QRLocalPisos: false,
  ImprimirPisos: false,
  VincularEntradasPendientes: false,
  CustomEmail: false,
  CustomDepartureTime: false,
  CobroDirecto: false,
  SubrubroAsRubro: false,
  RubroSubrubroUnificado: false,
  ResumenFinanciero: false,
  OcultarTotalIngresosEgresos: false,
  ExportarRostros: true,
  Totem: false,
  InteresMora: false,
  EspecialidadUnidad: false,
}
